module.exports = __webpack_public_path__ + "static/media/20240530075957_IMG_7409-min.b2c53e8e.JPG";